export default __webpack_public_path__ + "static/gender-neutral-posterior-c4b78fb8561ac4162f01998709c6adef.webp";